import ActionTypes from '../../../../../constants/ActionTypes';
import { IsetPurchaseFtthManhattanAction, ISingleProductState } from './types';

const initialState: ISingleProductState = {
  purchase: {},
};

const singleProductReducer = (
  state = initialState,
  action: IsetPurchaseFtthManhattanAction
): ISingleProductState => {
  switch (action.type) {
  case ActionTypes.MANHATTAN.FTTH.SINGLE_PRODUCT.SET_PURCHASE_MANHATTAN:
  case ActionTypes.MANHATTAN.FTTH.SINGLE_PRODUCT.CHANGE_PURCHASE_MANHATTAN:
  case ActionTypes.MANHATTAN.POST_OTT.SINGLE_PRODUCT.SET_PURCHASE_MANHATTAN:
  case ActionTypes.MANHATTAN.POST_OTT.SINGLE_PRODUCT.CHANGE_PURCHASE_MANHATTAN:
    return {
      ...state,
      purchase: action.payload.purchase
    };
  case ActionTypes.MANHATTAN.FTTH.SINGLE_PRODUCT.REMOVE_PURCHASE_FROM_SINGLE_PRODUCT:
  case ActionTypes.MANHATTAN.POST_OTT.SINGLE_PRODUCT.REMOVE_PURCHASE_FROM_SINGLE_PRODUCT:
    return {
      ...state,
      purchase: {}
    };
  }

  return state;
};

export default singleProductReducer;
